// Formatting helpers shared across usage/analytics tables.

// Compact number: 1234 -> "1.23K", 2_500_000 -> "2.5M", 1e9 -> "1B", etc.
// Suffixes: K (thousand), M (million), B (billion), T (trillion), Q (quadrillion).
// Values below 1000 are shown as a plain localized integer.
export function fmtCompact(n) {
  const num = Number(n) || 0;
  const abs = Math.abs(num);
  const units = [
    { v: 1e15, s: 'Q' },
    { v: 1e12, s: 'T' },
    { v: 1e9, s: 'B' },
    { v: 1e6, s: 'M' },
    { v: 1e3, s: 'K' },
  ];
  for (const u of units) {
    if (abs >= u.v) {
      // up to 2 decimals, trailing zeros stripped: 1.50K -> 1.5K, 2.00M -> 2M
      return (num / u.v).toFixed(2).replace(/\.?0+$/, '') + u.s;
    }
  }
  return num.toLocaleString();
}

// Compact USD cost: $1.2K / $3.4M for large amounts, and sensible precision for
// small ones ($12.34, $0.0012) since costs are often fractions of a cent.
export function fmtCostCompact(n) {
  const num = Number(n) || 0;
  const abs = Math.abs(num);
  if (abs >= 1e3) return '$' + fmtCompact(num);
  if (abs === 0) return '$0';
  if (abs >= 1) return '$' + num.toFixed(2);
  return '$' + num.toFixed(4);
}

// Exact USD for tooltips: full thousands-separated value, up to 6 decimals.
export function fmtCostExact(n) {
  return '$' + (Number(n) || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  });
}
